import * as React from "react";
import { HandicapRequirements_Policy } from "@kalabo/golfsavers-common";
import { Text } from "@uikit";
interface IProps {
  course_name?: string;
  handicap?: HandicapRequirements_Policy;
}

const CourseHandicapRequirements = ({ course_name, handicap }: IProps) => {
  if (!handicap) return null;
  if (handicap.enabled === "N/A" || handicap.enabled === "UNKNOWN") return null;

  return (
    <div>
      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Handicap Requirements
      </Text>
      {handicap.enabled === "NO" && (
        <>
          <Text element="p" size={15} leading={1.5} color="black90">
            There are no handicap requirements at {course_name}.
          </Text>
        </>
      )}
      {handicap.enabled === "YES" && (
        <>
          <Text element="p" size={15} leading={1.5} color="black90">
            The handicap requirements at {course_name} are as follows:
          </Text>
          <div>
            {handicap.male_handicap && (
              <Text bullet size={15} leading={1.5} color="black90">
                Max Male Handicap: <strong>{handicap.male_handicap}</strong>
              </Text>
            )}
            {handicap.female_handicap && (
              <Text
                bullet
                size={15}
                leading={1.5}
                className="mb-[20px]"
                color="black90"
              >
                Max Female Handicap: <strong>{handicap.female_handicap}</strong>
              </Text>
            )}
          </div>
          {handicap.certificate_required && (
            <Text element="p" size={15} leading={1.5} color="black90">
              Players are required to show a handicap certificate on arrival at
              the course.
            </Text>
          )}
        </>
      )}
    </div>
  );
};

export default CourseHandicapRequirements;
